module.exports = __webpack_public_path__ + "static/img/19.7f92bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/19.jpg
// module id = 188
// module chunks = 0